import React, { useRef } from 'react'
import { useSTheme } from 'styles/theme'
import { useOnClickOutside } from 'utils/customHooks'
import SBox from 'components/opinionless/SBox'
import { ContentWrapper } from './styles'
import ConditionalRender from 'utils/conditionalRender'

type FPopUpProps = {
    isOpen: boolean
    onClickOutside: () => void
    children?: React.ReactNode
}

const FPopUp = React.forwardRef((props: FPopUpProps, ref) => {
    const { isOpen, onClickOutside, children } = props
    const theme = useSTheme()
    const modalRef = useRef()

    if (onClickOutside) {
        useOnClickOutside(modalRef, onClickOutside)
    }

    return (
        <ConditionalRender if={isOpen}>
            <ContentWrapper isOpen={isOpen} overlayClassName={'remove-style'} className={'remove-style'}>
                <SBox px={'40px'} pt={'5px'} pb={'30px'} ref={modalRef}>
                    {children}
                </SBox>
            </ContentWrapper>
        </ConditionalRender>
    )
})

FPopUp.displayName = 'FPopUp'

export default FPopUp
